/**
 * FCT Account API
 * FCT Account API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: areche@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The WeeklyDoc model module.
 * @module model/WeeklyDoc
 * @version 1.0.0
 */
class WeeklyDoc {
    /**
     * Constructs a new <code>WeeklyDoc</code>.
     * @alias module:model/WeeklyDoc
     */
    constructor() { 
        
        WeeklyDoc.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>WeeklyDoc</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/WeeklyDoc} obj Optional instance to populate.
     * @return {module:model/WeeklyDoc} The populated <code>WeeklyDoc</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new WeeklyDoc();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('file_name')) {
                obj['file_name'] = ApiClient.convertToType(data['file_name'], 'String');
            }
            if (data.hasOwnProperty('download_link')) {
                obj['download_link'] = ApiClient.convertToType(data['download_link'], 'String');
            }
        }
        return obj;
    }


}

/**
 * The id of the document
 * @member {Number} id
 */
WeeklyDoc.prototype['id'] = undefined;

/**
 * The name of the weekly document
 * @member {String} file_name
 */
WeeklyDoc.prototype['file_name'] = undefined;

/**
 * The download link for the weekly document
 * @member {String} download_link
 */
WeeklyDoc.prototype['download_link'] = undefined;






export default WeeklyDoc;

